var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$utils.isClientType() == 'pc' && _vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading-img",attrs:{"src":require("./assets/image/pc/gif-jz.gif"),"fetchpriority":"high","alt":""}}),_c('div',{staticClass:"loader"})]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }